import PropTypes from 'prop-types'

import useAllDocumentsQuery from 'hooks/useAllDocumentsQuery'

const isSiblingPathArrays = (a = [], b = []) => {
	// must have same size
	if (a.length !== b.length) return false
	// must not have every path to be equal
	if (a.every((x, i) => x === b[i])) return false
	// must have every path part equal but the last
	return a.slice(0, a.length - 1).every((x, i) => x === b[i])
}

const getLast = a => a[a.length - 1]

const getNumber = a => parseInt(getLast(a), 10)

const isNextPathArrays = (a = [], b = []) => {
	if (!isSiblingPathArrays(a, b)) return false
	return getNumber(a) === getNumber(b) + 1
}

const isPrevPathArrays = (a = [], b = []) => {
	if (!isSiblingPathArrays(a, b)) return false
	return getNumber(a) === getNumber(b) - 1
}

const splitPath = (s = '') => s.split('/')
const getSlug = item => item.node.fields.modSlug
const isNext = slug => x => isNextPathArrays(splitPath(slug), splitPath(getSlug(x)))
const isPrev = slug => x => isPrevPathArrays(splitPath(slug), splitPath(getSlug(x)))

const slugToUrl = s => s.replace(/\d{2,}-/g, '')

const flatten = x => {
	if (!x?.node) return null
	return {
		...x.node.frontmatter,
		slug: x.node.slug,
		number: getNumber(x.node.fields.modSlug.split('/')),
		url: slugToUrl(x.node.fields.modSlug),
	}
}

const findAndFlatten = fn => slug => data => flatten(data?.find(fn(slug)))

const useDocumentsPagination = ({ slug }) => {
	const { edges } = useAllDocumentsQuery()
	if (!edges) return [null, null]
	const prev = findAndFlatten(isNext)(slug)(edges)
	const next = findAndFlatten(isPrev)(slug)(edges)
	return [prev, next]
}

useDocumentsPagination.propTypes = { slug: PropTypes.string }

export default useDocumentsPagination
